import React, { useEffect, useMemo, useState } from "react";
import "./payrunsmodal.css";
import { RiCloseLine } from "react-icons/ri";
import { SaveButton } from "../btn/Buttons";
import { base_url } from "../../utils/utils";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { NumberDecimalEntry, OnlyNumberEntry } from "../../utils/OtherFuncs";
import store from "../../redux/store";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../redux/slice/actionSlice";
import SmallModal from "./SmallModal";

const PayRunsModal = React.memo(
  ({
    setIsOpen,
    modalData,
    payable_days,
    month,
    year,
    fetchData,
    CommissionType,
  }) => {
    const [open, setOpen] = useState(false);
    const { user_id } = useSelector((state) => state.other);
    const [addData, setAddData] = useState({});
    useEffect(() => {
      if (!modalData) return;

      const {
        payment_status,
        paid_loanamount,
        EMI_PER_MONTH = 0,
        CL_OUTSTANDING_LOANS = 0,
        BASIC_PAY,
        basic_pay,
        HRA,
        hra,
        CONVEYANCE_ALLOWANCE,
        conveyance_allowance,
        MEDICAL_ALLOWANCE,
        medical_allowance,
        OTHER_ALLOWANCE,
        other_allowance,
        lop_days,
        TDS_AMOUNT,
        professional_tax,
        PROFESSIONAL_TAX_AMOUNT,
        gross_pay,
        PT_ELIGIBLE,
      } = modalData;

      const emi = Number(EMI_PER_MONTH);
      const outstanding = Number(CL_OUTSTANDING_LOANS);

      const finalLoanAmount =
        payment_status < 1
          ? paid_loanamount
            ? Number(paid_loanamount)
            : outstanding < emi
            ? outstanding
            : emi
          : Number(paid_loanamount || 0);

      const condition = payment_status > 0;
      const allowances = {
        BASIC_PAY: condition ? basic_pay : BASIC_PAY,
        HRA: condition ? hra : HRA,
        CONVEYANCE_ALLOWANCE: condition
          ? conveyance_allowance
          : CONVEYANCE_ALLOWANCE,
        MEDICAL_ALLOWANCE: condition ? medical_allowance : MEDICAL_ALLOWANCE,
        OTHER_ALLOWANCE: condition ? other_allowance : OTHER_ALLOWANCE,
        TDS_AMOUNT: condition ? TDS_AMOUNT || 0 : 0 || 0,
        PROFESSIONAL_TAX_AMOUNT: !PT_ELIGIBLE
          ? 0.0
          : condition
          ? professional_tax
          : PROFESSIONAL_TAX_AMOUNT,
        gross_pay: condition ? gross_pay : 0,
      };

      setAddData((prev) => ({
        ...prev,
        ...modalData,
        ...allowances,
        lop_days: lop_days || 0,
        paid_loanamount: finalLoanAmount,
      }));
    }, [modalData]);

    const commission_calulation = useMemo(() => {
      let TOTAL_COMMISSION = 0;
      let DOM_COMMISSION = 0;
      let COM_COMMISSION = 0;

      if (CommissionType && addData?.commission_products?.length > 0) {
        addData?.commission_products.forEach((item) => {
          const rate = Number(item.COMMISSION_RATE);
          const qty = item.QUANTITY;

          const commission = rate * qty;
          TOTAL_COMMISSION += commission;

          if (item.CAT_TYPE === 1) {
            DOM_COMMISSION += commission;
          } else if (item.CAT_TYPE === 2) {
            COM_COMMISSION += commission;
          }
        });
        return {
          COM_COMMISSION,
          DOM_COMMISSION,
          TOTAL_COMMISSION,
        };
      }
    }, [addData]);

    const handleSaveData = async () => {
      if (net_amount <= 0) {
        store.dispatch(setOpenAlert(true));
        store.dispatch(setMessAlert("Net Pay should be greater than 0"));
        return;
      } else if (addData?.paid_loanamount > +modalData?.CL_OUTSTANDING_LOANS) {
        store.dispatch(setOpenAlert(true));
        store.dispatch(
          setMessAlert(
            "Loan refund amount can't be greatethen outstanding loan amount"
          )
        );
        return;
      }

      const body = {
        action: CommissionType
          ? "saveOrUpdateCommissionBasedData"
          : "saveOrUpdateSalaryBasedData",
        agencyid: user_id,
        staffID: modalData?.ID,
        staffSalaryId: modalData?.type == "edit" ? modalData?.salary_id : "",
        staffRole: modalData?.ROLE,
        staffType: modalData?.STAFF_TYPE,
        month: month,
        year: year,

        payableDays: payable_days,
        lopDays: addData?.lop_days || 0,
        actualPayableDays: addData?.actual_payable_days || payable_days,

        // Commission Staff Salary Data
        domCommission:
          addData?.DOM_COMMISSION || commission_calulation?.DOM_COMMISSION,
        comCommission:
          addData?.COM_COMMISSION || commission_calulation?.COM_COMMISSION,
        commission_products: addData?.commission_products.filter(
          (v) => v?.QUANTITY != 0
        ),
        // otherAllowance: 0,

        // Normal Staff Salary Data
        basicPay: addData?.BASIC_PAY,
        houseRentAllowance: addData?.HRA,
        conveyanceAllowance: addData?.CONVEYANCE_ALLOWANCE,
        medicalAllowance: addData?.MEDICAL_ALLOWANCE,
        otherAllowance: addData?.OTHER_ALLOWANCE,

        incomeTax: 0,
        professionalTax: 0,
        esiAmount: addData?.esi_amount || esic_amount,
        pfAmount: addData?.pf_amount || pf_amount,
        lopAmount: addData?.lop_amount || 0.0,
        loanRefund: addData?.paid_loanamount || 0.0,
        advanceRefund: addData?.OUTSTANDING_ADVANCE || 0,
        tdsAmount: addData?.TDS_AMOUNT || tds_tax || 0,
        professionalTax: addData?.PROFESSIONAL_TAX_AMOUNT,
        netPay: net_amount?.toFixed(2),
        grossPay: addData?.gross_pay || gross_pay_amt,
      };
      try {
        store.dispatch(setLoadingMain(true));
        const response = await fetch(`${base_url}payroll/payrun.php`, {
          method: "POST",
          body: JSON.stringify(body),
        });

        const res = await response.json();
        if (res.success) {
          toast.success(res.message);
          setIsOpen(false);
          fetchData();
        } else if (!res.success) {
          toast.error(res.message);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        store.dispatch(setLoadingMain(false));
      }
    };

    const gross_pay_amt = useMemo(() => {
      console.log("commission ===>",addData?.COM_COMMISSION , commission_calulation?.COM_COMMISSION,
        addData?.DOM_COMMISSION , commission_calulation?.DOM_COMMISSION);
      
      const gross_pay = CommissionType
        ? (addData?.COM_COMMISSION || commission_calulation?.COM_COMMISSION) +
          (addData?.DOM_COMMISSION || commission_calulation?.DOM_COMMISSION) +
          Number(addData?.OTHER_ALLOWANCE)
        : Number(addData?.BASIC_PAY) +
          Number(addData?.HRA) +
          Number(addData?.CONVEYANCE_ALLOWANCE) +
          Number(addData?.MEDICAL_ALLOWANCE) +
          Number(addData?.OTHER_ALLOWANCE) -
          Number(addData?.lop_amount || 0);
          console.log("gross_pay ===>",gross_pay);
          
      return gross_pay;
    }, [addData]);

    const tds_tax = useMemo(() => {
      const tdsAmount =
        modalData?.TDS_ELIGIBLE == 1
          ? (Number(addData?.gross_pay || gross_pay_amt) *
              Number(modalData?.TDS_PERCENTAGE)) /
            100
          : 0.0;
      return tdsAmount;
    }, [addData]);
    // console.log("tds_tax ===", tds_tax);

    const calculatePF = (gross, eligible) => {
      if (eligible == 1) return ((gross * 12.36) / 100).toFixed(2);
      return "0.00";
    };

    const calculateESIC = (gross, eligible) => {
      if (eligible == 1) return ((gross * 0.75) / 100).toFixed(2);
      return "0.00";
    };
    const pf_amount = useMemo(
      () =>
        calculatePF(
          Number(addData?.gross_pay || gross_pay_amt),
          addData?.PF_ELIGIBLE
        ),
      [addData]
    );
    const esic_amount = useMemo(
      () =>
        calculateESIC(
          Number(addData?.gross_pay || gross_pay_amt),
          modalData?.ESIC_ELIGIBLE
        ),
      [addData]
    );

    const earnings = CommissionType
      ? [
          {
            label: "Domestic Commission",
            value:
              addData?.DOM_COMMISSION || commission_calulation?.DOM_COMMISSION,
          },
          {
            label: "Commercial Commission",
            value:
              addData?.COM_COMMISSION || commission_calulation?.COM_COMMISSION,
          },
          {
            label: "Other Allowance",
            value: addData?.OTHER_ALLOWANCE,
          },
        ]
      : [
          { label: "Basic", value: addData?.BASIC_PAY },
          { label: "House Rent Allowance", value: addData?.HRA },
          {
            label: "Conveyance Allowance",
            value: addData?.CONVEYANCE_ALLOWANCE,
          },
          { label: "Medical Allowance", value: addData?.MEDICAL_ALLOWANCE },
          { label: "Other Allowance", value: addData?.OTHER_ALLOWANCE },
        ];

    const deductions = [
      { label: "Income Tax", value: addData?.income_tax || 0.0, type: "both" },
      {
        label: "TDS Amount",
        value: Number(addData?.TDS_AMOUNT || tds_tax).toFixed(2),
        type: "both",
      },
      {
        label: "Professional Tax",
        value:
          typeof addData?.PROFESSIONAL_TAX_AMOUNT == "number"
            ? Number(addData?.PROFESSIONAL_TAX_AMOUNT).toFixed(2)
            : "0.00",
        type: "both",
      },
      {
        label: "ESI Amount",
        value: addData?.esi_amount || esic_amount,
        type: "both",
      },
      {
        label: "PF Amount",
        value: addData?.pf_amount || pf_amount,
        type: "both",
      },
      {
        label: "LOP Amount",
        value: addData?.lop_amount || "0.00",
        type: "salary",
      },
      {
        label: "Advance Amount",
        value: addData?.OUTSTANDING_ADVANCE || "0.00",
        type: "both",
      },
      {
        label: "Loan Refund (EMI / Month)",
        value: addData?.paid_loanamount,
        type: "both",
        input: true,
        onChange: (e) => {
          const value = e.target.value;
          if (
            (value?.length <= 10 && NumberDecimalEntry(value)) ||
            value === "" ||
            value === "-" ||
            !addData?.paid_loanamount
          ) {
            setAddData({
              ...addData,
              paid_loanamount:
                NumberDecimalEntry(value) || value === "" ? value : "",
            });
          }
        },
      },
    ];

    const net_amount = useMemo(() => {
      // const gross_pay = CommissionType
      //   ? Number(addData?.BASIC_PAY) +
      //     (addData?.COM_COMMISSION || commission_calulation?.COM_COMMISSION) +
      //     (addData?.DOM_COMMISSION || commission_calulation?.DOM_COMMISSION) +
      //     Number(addData?.OTHER_ALLOWANCE)
      //   : Number(addData?.BASIC_PAY) - Number(addData?.lop_amount || 0);

      const gross_pay = addData?.gross_pay || gross_pay_amt;
      console.log("gross_pay ===>", addData?.gross_pay, gross_pay_amt);
      
      // const normal_amt =
      //   Number(addData?.HRA) +
      //   Number(addData?.CONVEYANCE_ALLOWANCE) +
      //   Number(addData?.MEDICAL_ALLOWANCE) +
      //   Number(addData?.OTHER_ALLOWANCE);

      const deduction_amt =
        // Number(addData?.lop_amount || 0) +
        Number(addData?.TDS_AMOUNT || tds_tax || 0) +
        Number(addData?.PROFESSIONAL_TAX_AMOUNT || 0) +
        Number(addData?.OUTSTANDING_ADVANCE || 0) +
        Number(addData?.paid_loanamount || 0) +
        Number(addData?.pf_amount || pf_amount || 0) +
        Number(addData?.esi_amount || esic_amount || 0);

      // if (CommissionType) {
      //   return gross_pay - deduction_amt || 0;
      // }
      return Number(gross_pay) 
      // + Number(normal_amt) 
      - Number(deduction_amt);
    }, [addData]);
    return (
      <div className="payruns_modal_main_container">
        {/* Header */}
        <div
          className="payruns_modal_heading_container"
          style={{ position: "relative" }}
        >
          {[
            ["EMP_NAME", "Net pay"],
            ["EMP_CODE", net_amount?.toFixed(2)],
          ].map(([key, label]) => (
            <div key={key} className="payruns_modal_upper_heading">
              <p className="payruns_modal_description">{modalData?.[key]}</p>
              <p className="payruns_modal_description">{label}</p>
            </div>
          ))}
          <button
            className="close_btn"
            style={{
              marginLeft: "auto",
              background: "white",
              border: "none",
              right: "10px",
              top: "-8px",
              position: "absolute",
            }}
            onClick={() => {
              setAddData({});
              setIsOpen(false);
            }}
          >
            <RiCloseLine size={25} color="#2c3e50" />
          </button>
        </div>

        {/* Body */}
        <div
          className="payruns_modal_middle_container"
          style={{ height: addData?.payment_status > 0 ? "100%" : undefined }}
        >
          {!CommissionType && (
            <div className="payruns_modal_middle_container_inner_div">
              {[
                { label: "Payable Days", value: payable_days },
                {
                  label: "LOP Days",
                  value: addData?.lop_days,
                  input: true,
                  onChange: (e) => {
                    const value = e.target.value;
                    const numericValue = parseInt(value, 10);

                    console.log("value ===", value);

                    if (
                      !isNaN(numericValue) &&
                      numericValue >= 0 &&
                      numericValue <= payable_days
                    ) {
                      const lopAmount = (
                        (Number(addData?.BASIC_PAY) / payable_days) *
                        numericValue
                      ).toFixed(2);

                      setAddData({
                        ...addData,
                        lop_days: value, // Already validated
                        actual_payable_days: payable_days - numericValue,
                        lop_amount: lopAmount,
                        pf_amount: pf_amount,
                        esi_amount: esic_amount,
                      });
                    } else {
                      // Optionally clear values or handle invalid input
                      setAddData((prev) => ({
                        ...prev,
                        lop_days: "",
                        actual_payable_days: payable_days,
                        lop_amount: "0.00",
                      }));
                    }
                  },
                },
              ].map(({ label, value, input, onChange }) => (
                <div key={label} className="payruns_modal_inner_inner_div">
                  <p className="payruns_modal_description">{label}</p>
                  {input ? (
                    <PayRunsInput
                      disabled={addData?.payment_status > 0}
                      value={value}
                      onChange={onChange}
                    />
                  ) : (
                    <p className="payruns_modal_description_right">{value}</p>
                  )}
                </div>
              ))}
              <Separator />
              <div className="payruns_modal_inner_inner_div header_green">
                <p className="payruns_modal_description">Actual Payable Days</p>
                <p className="payruns_modal_description_right">
                  {addData?.actual_payable_days || payable_days}
                </p>
              </div>
              <Separator />
            </div>
          )}

          {CommissionType && (
            <>
              {modalData?.commission_products
                ?.filter((v) => v?.QUANTITY > 0)
                .map(({ PROD_NAME, QUANTITY }) => (
                  <div
                    key={PROD_NAME}
                    className="payruns_modal_inner_inner_div"
                  >
                    <p className="payruns_modal_description">{PROD_NAME}</p>
                    <p className="payruns_modal_description_right">
                      {QUANTITY}
                    </p>
                  </div>
                ))}
              <Separator />
            </>
          )}

          {/* Earnings */}
          <div className="payruns_modal_middle_container_inner_div">
            <div className="payruns_modal_inner_inner_div header_green">
              <p
                className="payruns_modal_description"
                style={{ color: "green", fontWeight: "700" }}
              >
                (+) EARNINGS
              </p>
              <p className="payruns_modal_description_right">AMOUNT</p>
            </div>
            <Separator />
            {earnings.map(({ label, value, input, onChange }) => (
              <div key={label} className="payruns_modal_inner_inner_div">
                <p className="payruns_modal_description">{label}</p>
                {input ? (
                  <PayRunsInput
                    value={value}
                    disabled={addData?.payment_status > 0}
                    onChange={onChange}
                  />
                ) : (
                  <p className="payruns_modal_description_right">{value}</p>
                )}
              </div>
            ))}
            <Separator />
          </div>

          {/* Deductions */}
          <div className="payruns_modal_middle_container_inner_div">
            <div className="payruns_modal_inner_inner_div header_red">
              <p
                className="payruns_modal_description"
                style={{ color: "#dc3545", fontWeight: "700" }}
              >
                (-) DEDUCTIONS
              </p>
              <p className="payruns_modal_description_right">AMOUNT</p>
            </div>
            <Separator />
            {deductions
              .filter(
                ({ type }) =>
                  type === "both" ||
                  (type === "salary" && !CommissionType) ||
                  (type === "commission" && CommissionType)
              )
              .map(({ label, value, input, onChange }) => (
                <div key={label} className="payruns_modal_inner_inner_div">
                  <p className="payruns_modal_description">{label}</p>
                  {input ? (
                    <PayRunsInput
                      value={value}
                      disabled={addData?.payment_status > 0}
                      onChange={onChange}
                    />
                  ) : (
                    <p className="payruns_modal_description_right">{value}</p>
                  )}
                </div>
              ))}
            <Separator />
            <div className="payruns_modal_inner_inner_div">
              <p className="payruns_modal_description">NET PAY</p>
              <p className="payruns_modal_description_right">
                {net_amount?.toFixed(0)}
              </p>
            </div>
          </div>
        </div>

        {(addData.payment_status == 0 || !addData.payment_status) && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "30px",
            }}
          >
            <SaveButton
              onClick={() =>
                CommissionType ? setOpen(true) : handleSaveData()
              }
            />
          </div>
        )}

        {open && (
          <SmallModal
            title={"Confirm"}
            isOpen={open}
            setIsOpen={setOpen}
            okBtnText={"SAVE"}
            okbtn
            mess={
              "Please verify that the commission amount has been correctly set for each delivery staff for each product. The pay amount will not be editable once saved."
            }
            ok_btn_click={() => handleSaveData()}
          />
        )}
      </div>
    );
  }
);
const Separator = () => (
  <div className="separator">
    ---------------------------------------------------
  </div>
);

const PayRunsInput = React.memo(({ value, onChange, className, disabled }) => {
  return (
    <div
      className=""
      style={{
        flex: 1,
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        border: "none",
      }}
    >
      <input
        disabled={disabled}
        type="text"
        value={value}
        onChange={onChange}
        className={`${className} payruns_modal_description_right_input`}
      />
    </div>
  );
});

export default PayRunsModal;
